import styled from "styled-components";

export const TicketInfoWrapper = styled.div`
    position: relative;
    padding: 12px 20px 30px 20px;
    gap: 16px;
    overflow: auto;
    max-height: 80vh;
`;

export const TicketInfoContentWrapper = styled.div`
    gap: 16px;
    display: grid;
    grid-template-columns: 50% 50%;
    margin-right: 20px;

    div:nth-child(1),
    div:nth-child(2),
    div:nth-child(3),
    div:nth-child(4) {
        grid-column: 1 / span 2;
    }
`;